
$(function() {
    var $tabCarousel = $('.js-sub-nav-tabs');

    if ($tabCarousel.length > 0) {
        var windowWidth = window.innerWidth,
            $carouselTabs = $tabCarousel.find('.js-sub-nav-tabs-list'),
            $carouselTabItems = $tabCarousel.find('.sub-nav-tabs__item'),
            $carouselBelt = $tabCarousel.find('.js-sub-nav-tabs-belt'),
            $carouselArrowLeft = $tabCarousel.find('.js-sub-arrow-left'),
            $carouselArrowRight = $tabCarousel.find('.js-sub-arrow-right'),
            $activeCarouselTab = $tabCarousel.find('sub-nav-tabs__item--active'),
            $innerCarousel = $tabCarousel.find('js-sub-nav-tabs-carousel'),
            carouselViewport;

        alphaCarouselInit();
    }


    function setupCarousel() {
        carouselViewport = $carouselBelt.width();

        var $lastTabItem =  $carouselTabItems.eq( $carouselTabItems.length - 1);
            totalWidthOfElementsInPx =  ($lastTabItem.offset().left + $lastTabItem.width() ) - $carouselBelt.offset().left;


        totalWidthOfElementsInPx = parseInt(totalWidthOfElementsInPx, 10);

        //setup width
        $carouselTabs.css('width', totalWidthOfElementsInPx + 50 + 'px'); //accounting for unloaded typekit fonts

        if (totalWidthOfElementsInPx > carouselViewport) {
            $carouselTabs.css('width', totalWidthOfElementsInPx + 100 + 'px');

            $carouselArrowLeft.css('display', 'block');
            $carouselArrowRight.css('display', 'block');
        } else {
            $carouselArrowLeft.css('display', 'none');
            $carouselArrowRight.css('display', 'none');
        }

        if (document.getElementsByClassName('sub-nav-tabs__item--active')[0] !== undefined) {
            var innerWidth = document.getElementsByClassName('js-sub-nav-tabs-carousel')[0].offsetWidth;
            var gradientWidth = 70;
            var tabPosition = document.getElementsByClassName('sub-nav-tabs__item--active')[0].getBoundingClientRect().right;

            if (innerWidth < tabPosition) {
                var xPos = (tabPosition - innerWidth) + gradientWidth;
                document.getElementsByClassName('js-sub-nav-tabs-carousel')[0].style.marginLeft = '-' + xPos + 'px'
            }
        }

    }

    function resetCarouselStyles() {

        $carouselTabs.css({
            'width': 'auto'            
        });
    }


    function carouselLogic(direction) {
        var marginLeft = $carouselTabs.css('margin-left');
        var currentMargin = !!marginLeft ? parseInt($carouselTabs.css('margin-left')) : 0;

        if (direction === 'next') {
            //Find right most element that is fully shown on screen            

            $carouselTabItems.each(function(index) {
                var thisElement = $(this);
                var thisWidth = thisElement.width();
                var rightPosition = thisElement.offset().left + thisWidth;

                if (rightPosition+currentMargin > carouselViewport) {
                    $carouselTabs.css('margin-left', (currentMargin-(thisWidth-30)) + 'px');
                    //break
                    return false;
                }
            });
        } else {            
            $carouselTabItems.each(function(index) {
                var thisElement = $(this);
                var leftPosition = thisElement.offset().left;

                if (leftPosition < 0) {
                    var elementWidth = $(this).width();
                    $carouselTabs.css('margin-left', '0px');
                    //break
                    return false;
                }
            });
        }        
    }


    function alphaCarouselInit() {

        //Setup variables
        setupCarousel();

        // //bind Events
        $carouselArrowLeft.on('click', function(ev) {
            ev.preventDefault();
            carouselLogic('prev');
        });

        $carouselArrowRight.on('click', function(ev) {
            ev.preventDefault();
            carouselLogic('next');
        });

        //setup windowsize event handler
        windowResizeHandler();
    }

    function windowResizeHandler() {
        var resizeTimer;

        $(window).on('resize.carouselTabs', function() {

            clearTimeout(resizeTimer);

            resizeTimer = setTimeout(function() {
                windowWidth = window.innerWidth;
                
                setupCarousel();
            }, 500);
        });
    }
});